export default {
  nullValue: 'Keine Daten',
};
